/**
 * @generated SignedSource<<cbfc6500f3be6b18f5105e195ebd6780>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorMessage",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errorDetails",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v7 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  (v2/*: any*/)
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOrder",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "proposedValue",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyName",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "RosterLoadPropertyMaskElement",
  "kind": "LinkedField",
  "name": "mask",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "RosterLoadProperty",
  "kind": "LinkedField",
  "name": "keys",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v8/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "RosterLoadProperty",
  "kind": "LinkedField",
  "name": "properties",
  "plural": true,
  "selections": [
    (v2/*: any*/),
    (v10/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "originalValue",
      "storageKey": null
    },
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "required",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isKey",
      "storageKey": null
    },
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pattern",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patternErrorMessage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PossibleValue",
      "kind": "LinkedField",
      "name": "possibleValues",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showsUp",
          "storageKey": null
        },
        (v11/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/)
],
v16 = [
  (v2/*: any*/)
],
v17 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "RosterLoadComponent",
    "kind": "LinkedField",
    "name": "parentLocation",
    "plural": false,
    "selections": (v16/*: any*/),
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "RosterLoadComponent",
    "kind": "LinkedField",
    "name": "parentPractitioner",
    "plural": false,
    "selections": (v16/*: any*/),
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RosterLoadDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "InProgressRosterLoadFragment"
              }
            ],
            "type": "RosterLoad",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RosterLoadDetailsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "downloadUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdOn",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "createdBy",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userName",
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoadLegalContractLineOfService",
                "kind": "LinkedField",
                "name": "legalContractLinesOfService",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LegalContractLineOfService",
                    "kind": "LinkedField",
                    "name": "linesOfService",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LineOfService",
                        "kind": "LinkedField",
                        "name": "lineOfService",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LegalContract",
                        "kind": "LinkedField",
                        "name": "contract",
                        "plural": false,
                        "selections": (v7/*: any*/),
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoadComponent",
                "kind": "LinkedField",
                "name": "addedBillingAddresses",
                "plural": true,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoadComponent",
                "kind": "LinkedField",
                "name": "changedBillingAddresses",
                "plural": true,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoadComponent",
                "kind": "LinkedField",
                "name": "addedBillingGroups",
                "plural": true,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoadComponent",
                "kind": "LinkedField",
                "name": "changedBillingGroups",
                "plural": true,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoadComponent",
                "kind": "LinkedField",
                "name": "addedLocations",
                "plural": true,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoadComponent",
                "kind": "LinkedField",
                "name": "changedLocations",
                "plural": true,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoadComponent",
                "kind": "LinkedField",
                "name": "addedPractitioners",
                "plural": true,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoadComponent",
                "kind": "LinkedField",
                "name": "changedPractitioners",
                "plural": true,
                "selections": (v15/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoadComponent",
                "kind": "LinkedField",
                "name": "addedPractitionerLocations",
                "plural": true,
                "selections": (v17/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterLoadComponent",
                "kind": "LinkedField",
                "name": "changedPractitionerLocations",
                "plural": true,
                "selections": (v17/*: any*/),
                "storageKey": null
              }
            ],
            "type": "RosterLoad",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6819998bf2d6905e85dffe94991937d8",
    "id": null,
    "metadata": {},
    "name": "RosterLoadDetailsQuery",
    "operationKind": "query",
    "text": "query RosterLoadDetailsQuery(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on RosterLoad {\n      id\n      status\n      errorMessage\n      errorDetails\n      fileName\n      ...InProgressRosterLoadFragment\n    }\n    id\n  }\n}\n\nfragment InProgressRosterLoadFragment on RosterLoad {\n  id\n  status\n  fileName\n  downloadUrl\n  createdOn\n  createdBy {\n    userName\n    id\n  }\n  legalContractLinesOfService {\n    linesOfService {\n      lineOfService {\n        name\n        id\n      }\n      contract {\n        name\n        id\n      }\n      id\n    }\n    id\n  }\n  addedBillingAddresses {\n    id\n    status\n    keys {\n      id\n      displayOrder\n      proposedValue\n      propertyName\n      mask {\n        type\n        value\n      }\n    }\n    properties {\n      id\n      propertyName\n      proposedValue\n      originalValue\n      displayOrder\n      required\n      isKey\n      mask {\n        type\n        value\n      }\n      pattern\n      patternErrorMessage\n      possibleValues {\n        showsUp\n        value\n      }\n    }\n  }\n  changedBillingAddresses {\n    id\n    status\n    keys {\n      id\n      displayOrder\n      proposedValue\n      propertyName\n      mask {\n        type\n        value\n      }\n    }\n    properties {\n      id\n      propertyName\n      proposedValue\n      originalValue\n      displayOrder\n      required\n      isKey\n      mask {\n        type\n        value\n      }\n      pattern\n      patternErrorMessage\n      possibleValues {\n        showsUp\n        value\n      }\n    }\n  }\n  addedBillingGroups {\n    id\n    status\n    keys {\n      id\n      displayOrder\n      proposedValue\n      propertyName\n      mask {\n        type\n        value\n      }\n    }\n    properties {\n      id\n      propertyName\n      proposedValue\n      originalValue\n      displayOrder\n      required\n      isKey\n      mask {\n        type\n        value\n      }\n      pattern\n      patternErrorMessage\n      possibleValues {\n        showsUp\n        value\n      }\n    }\n  }\n  changedBillingGroups {\n    id\n    status\n    keys {\n      id\n      displayOrder\n      proposedValue\n      propertyName\n      mask {\n        type\n        value\n      }\n    }\n    properties {\n      id\n      propertyName\n      proposedValue\n      originalValue\n      displayOrder\n      required\n      isKey\n      mask {\n        type\n        value\n      }\n      pattern\n      patternErrorMessage\n      possibleValues {\n        showsUp\n        value\n      }\n    }\n  }\n  addedLocations {\n    id\n    status\n    keys {\n      id\n      displayOrder\n      proposedValue\n      propertyName\n      mask {\n        type\n        value\n      }\n    }\n    properties {\n      id\n      propertyName\n      proposedValue\n      originalValue\n      displayOrder\n      required\n      isKey\n      mask {\n        type\n        value\n      }\n      pattern\n      patternErrorMessage\n      possibleValues {\n        showsUp\n        value\n      }\n    }\n  }\n  changedLocations {\n    id\n    status\n    keys {\n      id\n      displayOrder\n      proposedValue\n      propertyName\n      mask {\n        type\n        value\n      }\n    }\n    properties {\n      id\n      propertyName\n      proposedValue\n      originalValue\n      displayOrder\n      required\n      isKey\n      mask {\n        type\n        value\n      }\n      pattern\n      patternErrorMessage\n      possibleValues {\n        showsUp\n        value\n      }\n    }\n  }\n  addedPractitioners {\n    id\n    status\n    keys {\n      id\n      displayOrder\n      proposedValue\n      propertyName\n      mask {\n        type\n        value\n      }\n    }\n    properties {\n      id\n      propertyName\n      proposedValue\n      originalValue\n      displayOrder\n      required\n      isKey\n      mask {\n        type\n        value\n      }\n      pattern\n      patternErrorMessage\n      possibleValues {\n        showsUp\n        value\n      }\n    }\n  }\n  changedPractitioners {\n    id\n    status\n    keys {\n      id\n      displayOrder\n      proposedValue\n      propertyName\n      mask {\n        type\n        value\n      }\n    }\n    properties {\n      id\n      propertyName\n      proposedValue\n      originalValue\n      displayOrder\n      required\n      isKey\n      mask {\n        type\n        value\n      }\n      pattern\n      patternErrorMessage\n      possibleValues {\n        showsUp\n        value\n      }\n    }\n  }\n  addedPractitionerLocations {\n    id\n    status\n    keys {\n      id\n      displayOrder\n      proposedValue\n      propertyName\n      mask {\n        type\n        value\n      }\n    }\n    properties {\n      id\n      propertyName\n      proposedValue\n      originalValue\n      displayOrder\n      required\n      isKey\n      mask {\n        type\n        value\n      }\n      pattern\n      patternErrorMessage\n      possibleValues {\n        showsUp\n        value\n      }\n    }\n    parentLocation {\n      id\n    }\n    parentPractitioner {\n      id\n    }\n  }\n  changedPractitionerLocations {\n    id\n    status\n    keys {\n      id\n      displayOrder\n      proposedValue\n      propertyName\n      mask {\n        type\n        value\n      }\n    }\n    properties {\n      id\n      propertyName\n      proposedValue\n      originalValue\n      displayOrder\n      required\n      isKey\n      mask {\n        type\n        value\n      }\n      pattern\n      patternErrorMessage\n      possibleValues {\n        showsUp\n        value\n      }\n    }\n    parentLocation {\n      id\n    }\n    parentPractitioner {\n      id\n    }\n  }\n}\n"
  }
};
})();

node.hash = "a9be4be0d2d8de580371e11bbbe8c25c";

export default node;
